// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3KIRQ","share-button":"_1_Ruy","whatsapp":"_3snq1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/WhatsAppShareButton.scss
// module id = ./src/components/ShareModal/WhatsAppShareButton.scss
// module chunks = 4